import { useEffect, useRef, useState } from 'react'

export default function useTypewriter(text, { speedMs = 50, pauseMs = 500 } = {}) {
  const [out, setOut] = useState('')
  const iRef = useRef(0)
  const [done, setDone] = useState(false)

  useEffect(() => {
    if (!text) {
      setOut('')
      setDone(true) 
      return
    }

    setOut('')
    setDone(false)
    iRef.current = 0

    let intervalId = null
    let timeoutId = null

    const startTyping = () => {
      timeoutId = setTimeout(() => {
        intervalId = setInterval(() => {
          iRef.current += 1
          setOut(text.slice(0, iRef.current))
          if (iRef.current >= text.length) {
            clearInterval(intervalId)
            setDone(true)
            timeoutId = setTimeout(() => {
              iRef.current = 0
              setOut('')
              startTyping()
            }, pauseMs)
          }
        }, speedMs)
      }, pauseMs)
    }

    startTyping()

    return () => {
      clearInterval(intervalId)
      clearTimeout(timeoutId)
    }
  }, [text, speedMs, pauseMs])

  return [out, done]
}

